import { useSelector } from 'react-redux'

import { COMMON_MIXPANEL_PAGE } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/mixpanelConstants'
import { useForkedTriageAvailability } from '@lyrahealth-inc/shared-app-logic/src/features/common/hooks/useForkedTriageAvailability'
import { INDIVIDUAL_COACHING_TOOLKIT } from '@lyrahealth-inc/shared-app-logic/src/features/wellnessToolkit/constants'
import { WELLNESS_TOOLKIT_PROMOTION } from '@lyrahealth-inc/shared-app-logic/src/features/wellnessToolkit/types'

import { useToolkitAvailabilityMap } from './useToolkitAvailabilityMap'
import { getCustomerPropertiesMap } from '../../data/customer/customerSelectors'

/**
 * Hook to be used for microsite multi cta availability
 * NOTE: only use in microsite homepage (i.e. do not use in homebase/logged in)
 */
export const useIsMultiCtaPathwaysAvailable = () => {
  const customerPropertiesMap = useSelector(getCustomerPropertiesMap)?.toJS()
  const libraryDisabled = customerPropertiesMap?.libraryDisabled === 'true'
  const { availabilityByToolkit } = useToolkitAvailabilityMap(COMMON_MIXPANEL_PAGE.FORKED_TRIAGE)
  const { isToolkitAvailable: isIndividualCoachingAvailable, reasons: reasonsForIndividualCoachingAvailabilityStatus } =
    availabilityByToolkit[INDIVIDUAL_COACHING_TOOLKIT]
  const { isToolkitAvailable: isParentCoachingToolkitAvailable, reasons: reasonsForParentCoachingAvailabilityStatus } =
    availabilityByToolkit[WELLNESS_TOOLKIT_PROMOTION.PARENT]

  const { availableOptions, reasons, forkedTriageAvailable } = useForkedTriageAvailability({
    customerPropertiesMap,
    coachingToolkitAvailability: {
      individual: {
        available: isIndividualCoachingAvailable,
        reasons: reasonsForIndividualCoachingAvailabilityStatus,
      },
      parent: {
        available: isParentCoachingToolkitAvailable,
        reasons: reasonsForParentCoachingAvailabilityStatus,
      },
    },
  })

  return {
    showMultiCTAPathways: !libraryDisabled && forkedTriageAvailable,
    availableOptions,
    reasons,
  }
}
